// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3wdAP","label":"SetPasswdForm_label__24FbB"};